module.exports = ".row{\r\n    padding:20px 0px 0px;\r\n}\r\n\r\n.row:nth-child(odd){\r\n    background: #f3f3f3;\r\n}\r\n\r\n.form-control{\r\n    width: 150px;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/Promotions/general-promotion-list/gen-pro-list/gen-pro-list.component.css
// module id = ./src/app/hrms/Promotions/general-promotion-list/gen-pro-list/gen-pro-list.component.css
// module chunks = main